import { useRef, useEffect } from "react";

import { Button, ChevronLeftSVG } from "@newsela/angelou";
import PropTypes from "prop-types";

import { dropdownListCss } from "@/view/ActionsDropdown/ActionsDropdown.style";
import {
  buttonIconCss,
  buttonWrapperCss,
  headerCss,
  headerWrapperCss,
} from "./SubMenu.style";

const propTypes = {
  headerText: PropTypes.string.isRequired,
  onBackClick: PropTypes.func,
  menuItems: PropTypes.node,
};

const SubMenu = ({ headerText, onBackClick, menuItems }) => {
  const backButtonRef = useRef(null);

  useEffect(() => {
    backButtonRef.current.focus();
  }, []);

  return (
    <>
      <div css={headerWrapperCss}>
        <Button
          ariaProps={{ "aria-label": "Back to additional actions" }}
          flavor={Button.flavors.tertiary}
          size={Button.sizes.md}
          __cssFor={{
            root: buttonWrapperCss,
            Icon: {
              root: buttonIconCss,
            },
          }}
          icon={{
            SvgComponent: ChevronLeftSVG,
          }}
          onClick={onBackClick}
          ref={backButtonRef}
        />
        <h2 css={headerCss}>{headerText}</h2>
      </div>
      <ul role="list" css={dropdownListCss}>
        {menuItems}
      </ul>
    </>
  );
};

SubMenu.propTypes = propTypes;

export default SubMenu;
